import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "MediaFiles";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "", data);
};

export const save = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "save", data);
};

export const remove = async (id) => {
    return await destroy(baseRoute, "", id);
};

export const search = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "search", data);
};

export const getMediaOf = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "get_media_of", data);
};

export const getMediaListOf = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "get_media_list_of", data);
};

export const upload = async (uploadData) => {
    return await post(baseRoute, "upload", uploadData);
};

const mediaFilesService = {
    findAll,
    findById,
    add,
    update,
    save,
    remove,
    upload,
    search,
    getMediaOf,
    getMediaListOf
}

export default mediaFilesService;